import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hayfever-unblock',
  templateUrl: './hayfever-unblock.component.html',
  styleUrls: ['./hayfever-unblock.component.css', '../style/global.css'],
})
export class HayfeverUnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/hayfever/images/logo.svg'
    );
  }

  get appname() {
    return '花粉症ドクター';
  }
}
